import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import {
  FUNC_DEFAULT,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME,
} from 'constants';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputUploadDocumentsSelectIdTypeSwitch = ({
  information,
  setInformation = FUNC_DEFAULT,
  validation,
  setValidation = FUNC_DEFAULT,
}) => {
  const { t } = useLang();

  const isDriverLicenceSelected =
    information[
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME
    ];

  const handleChangeDocumentUpload = (e, docType) => {
    e.preventDefault();
    e.stopPropagation();

    let newInformation = {
      ...information,
      [VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME]:
        !isDriverLicenceSelected,
    };

    if (docType === 'D') {
      newInformation = {
        ...newInformation,
        [VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME]: null,
      };
    }

    if (docType === 'P') {
      newInformation = {
        ...newInformation,
        [VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME]: null,
        [VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME]: null,
      };
    }

    const newValidation = {
      ...validation,
      [VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME]: '',
      [VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME]: '',
      [VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME]: '',
    };

    console.log(
      `⭐ FormInputUploadDocumentsSelectIdTypeSwitch 👉 handleChangeDocumentUpload ➡️ newInformation ↩`,
      newInformation
    );
    console.log(
      `⭐ FormInputUploadDocumentsSelectIdTypeSwitch 👉 handleChangeDocumentUpload ➡️ newValidation ↩`,
      newValidation
    );
    setInformation(newInformation);
    setValidation(newValidation);
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 =
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME + '1';

    return (
      <>
        <FormCheckboxRadio
          name={VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME}
          className={`${formCheckRadioClassName1} ${
            isDriverLicenceSelected && 'active'
          }`}
          label={t('label_upload_documents_driver_licence_checkbox')}
          isChecked={isDriverLicenceSelected}
          onClick={(e) => handleChangeDocumentUpload(e, 'D')}
          styles={{ marginRight: '16px' }}
          labelStyles={{ fontWeight: '500!important' }}
        />
      </>
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 =
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME + '2';

    return (
      <>
        <FormCheckboxRadio
          name={VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME}
          className={`${formCheckRadioClassName2} ${
            !isDriverLicenceSelected && 'active'
          }`}
          label={t('label_upload_documents_passport_checkbox')}
          isChecked={!isDriverLicenceSelected}
          onClick={(e) => handleChangeDocumentUpload(e, 'P')}
          styles={{ marginRight: '0px' }}
          labelStyles={{ fontWeight: '500!important' }}
        />
      </>
    );
  };

  return (
    <FormGroupStyled>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  position: relative;
  ${Fade};

  img {
    width: 100%;
    height: 230px;
    object-fit: contain;
    border-radius: 12px;
  }
`;

export default FormInputUploadDocumentsSelectIdTypeSwitch;
